export const LEGAL_FORM_OPTIONS = [
  { value: "einzelunternehmen", label: "Einzelunternehmen" },
  { value: "freiberufler", label: "Freiberufler/in" },
  { value: "gbr", label: "GbR" },
  { value: "ek", label: "e. K. (eingetragener Kaufmann)" },
  { value: "gmbh", label: "GmbH" },
  { value: "ug", label: "UG (haftungsbeschränkt)" },
  { value: "ohg_kg", label: "OHG / KG" },
  { value: "sonstige", label: "Sonstige Rechtsform" },
];

export const NEEDS_REPRESENTATIVE = ["gbr", "gmbh", "ug", "ohg_kg", "sonstige"];
export const NEEDS_REGISTER = ["ek", "gmbh", "ug", "ohg_kg"];
